import { Component } from "../components/index"
import { qsa, qs } from "../utils/index"
import gsap from "gsap"

export default class SliderReview extends Component {
  constructor(obj) {
    super(obj)
    this.currentSlide = 0
    this.slider = qs(".sliderReview-slider", this.el)
    this.widgetSlides = qsa(".jdgm-rev", this.el)
    this.slides = qsa(".slider-item", this.el)
    this.writeReview = qs(".jdgm-write-rev-link", this.el)
    this.cancelReview = qs(".jdgm-cancel-rev", this.el)
    this.smooth = obj.renderer.smooth || false

    this.data = []
    this.observe()
  }

  setup() {
    let total = 0

    if (this.widgetSlides.length === 0) {
      gsap.set(this.el, { display: "none" })
      requestAnimationFrame(() => {
        this.smooth?.update()
      })
      return
    }

    gsap.set(this.writeReview, { clearProps: "all" })
    this.writeReview.setAttribute("aria-expanded", "false")

    this.widgetSlides.forEach(slide => {
      const stars = qsa(".jdgm--on", slide)
      const title = qs(".jdgm-rev__title", slide)
      const review = qs(".jdgm-rev__body", slide)
      const name = qs(".jdgm-rev__author", slide)
      const obj = {
        stars: stars.length,
        title: title?.innerText,
        review: review?.innerText,
        name: name?.innerText,
      }
      this.data.push(obj)
    })
    this.slides.forEach((slide, index) => {
      const count = index + 1
      if (count <= this.data.length - 1) {
        const review = qs(".slider-review", slide)
        const author = qs(".review-name", slide)
        review.innerText = this.data[count].review
        author.innerText = this.data[count].name
        total += 1
      } else {
        slide.style.display = "none"

        slide.remove()
      }
    })

    gsap.set(this.slider, { width: `${total * 32}rem` })
  }

  updateScroll = () => {
    setTimeout(() => {
      this.smooth?.update()
    }, 500)
  }

  observe = () => {
    // Prefer the cached node you grabbed in constructor:
    const target = qs(".slider-item")
    if (!target || !(target instanceof Node)) {
      console.warn("[SliderReview] observe(): target not found")
      return
    }

    // Keep a reference so we can disconnect later
    this.mo?.disconnect?.()
    this.mo = new MutationObserver(() => {
      // Any DOM mutation inside target triggers a scroll update
      this.updateScroll()
    })

    this.mo.observe(target, {
      childList: true,
      attributes: true,
      characterData: true,
      subtree: true,
    })
  }

  queueUpdate = () => {
    const stars = qsa(".jdgm-form__fieldset .jdgm-star")

    stars.forEach(star => {
      star.setAttribute("data-taxi-ignore", "true")
    })

    setTimeout(() => {
      this.smooth?.update()
    }, 1000)
  }

  on() {
    this.writeReview?.addEventListener("click", () => {
      this.queueUpdate() // form opens

      const ac = new AbortController()
      const { signal } = ac
      const cleanup = () => ac.abort()
      const form = qs(".jdgm-form", this.el)

      document.addEventListener(
        "click",
        e => {
          if (!e.target.closest(".jdgm-cancel-rev")) return
          this.queueUpdate() // form collapses
          cleanup()
        },
        { signal, capture: true }
      )

      form.addEventListener(
        "submit",
        e => {
          this.queueUpdate() // form collapses
          cleanup()
        },
        { signal, capture: true }
      )
    })
  }

  off() {}
}
